import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {StatisticsApiService} from '../../statistics.api.service';
import {Time} from '../types/time.statistics.parameter.type';
import {ClusterID} from '../types/cluster-id.statistics.parameter.type';
import {StorageStatistics, StorageStatisticsResponse} from './storages.statistic.model';

@Injectable({
  providedIn: 'root'
})
export class StoragesStatisticsService {

  constructor(
    private readonly api: StatisticsApiService
  ) {
  }

  public get(time: Time, clusterId: ClusterID): Observable<StorageStatistics> {
    return this.api
      .get(`/s3`, {time, clusterId})
      .pipe(
        map((response: StorageStatisticsResponse) => response.data)
      );
  }
}
